module.exports = __webpack_public_path__ + "static/home_espacepro_v2-e0027cd94daa2a12790131ad7bc3e5d6.jpg";